/*
  Dasom Skin Scan - Layer 2: deep analysis questionnaire.
  After the instant on-device scan, the customer can opt into a richer read. We collect
  context the heuristic can't see (age, skin type/tone, current routine, past treatments and
  how they went, biggest complaint, budget) and - only with explicit consent - their scan
  photo, then send it to the Dasom AI (Gemini vision) for a personalised, budget-aware
  routine + visible-focus-area read. Cosmetic guidance only, never a diagnosis.

  Privacy: the photo + answers are sent transiently for THIS analysis and are not stored.

  API: DasomDeepAnalysis.open({ stage, lastShot, scan, addToCart, link, cartOk, onBack })
*/
window.DasomDeepAnalysis = (function () {
  'use strict';

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); }

  // Question schema. Single = one choice; multi = several; text = free note.
  var Q = [
    { k: 'age', label: 'Your age', type: 'single', opts: ['Under 20', '20s', '30s', '40s', '50s', '60+'] },
    { k: 'skin_type', label: 'Skin type', type: 'single', opts: ['Dry', 'Oily', 'Combination', 'Normal', 'Sensitive', 'Not sure'] },
    { k: 'tone', label: 'Skin tone (optional)', type: 'single', opts: ['Fair', 'Light', 'Medium', 'Tan', 'Deep', 'Prefer not to say'] },
    { k: 'ethnicity', label: 'Background (optional)', type: 'single', opts: ['East Asian', 'South Asian', 'Black', 'Hispanic / Latino', 'Middle Eastern', 'White', 'Mixed / Other', 'Prefer not to say'] },
    { k: 'concerns', label: 'Biggest concerns', type: 'multi', opts: ['Dullness', 'Dark spots', 'Uneven tone', 'Fine lines', 'Texture / pores', 'Redness', 'Dryness', 'Breakouts', 'Firmness'] },
    { k: 'routine', label: 'Current routine', type: 'multi', opts: ['Cleanser', 'Toner', 'Serum', 'Moisturizer', 'SPF', 'Exfoliant', 'Retinol', 'Nothing yet'] },
    { k: 'treatments', label: 'Treatments tried', type: 'multi', opts: ['None', 'Facials', 'Chemical peel', 'Laser', 'Microneedling', 'Botox', 'Filler', 'Other'] },
    { k: 'budget', label: 'Monthly skincare budget (CAD)', type: 'single', opts: ['Under $100', '$100-300', '$300-600', '$600+'] }
  ];

  function open(opts) {
    var stage = opts.stage;
    var state = {}; // answers: k -> string | [strings]
    Q.forEach(function (q) { state[q.k] = q.type === 'multi' ? [] : ''; });
    var complaint = '';

    function chipGroup(q) {
      return '<div class="dss-qgroup" data-q="' + q.k + '"><div class="dss-qlabel">' + esc(q.label) + '</div><div class="dss-qchips">' +
        q.opts.map(function (o) { return '<button type="button" class="dss-qchip" data-v="' + esc(o) + '">' + esc(o) + '</button>'; }).join('') +
        '</div></div>';
    }

    stage.innerHTML =
      '<p class="dss-eyebrow">Deep analysis</p>' +
      '<h3 class="dss-h">A few questions for a deeper read</h3>' +
      '<p class="dss-sub">This sharpens your routine using what your scan can’t see. Takes about 30 seconds, and every question is optional.</p>' +
      '<div class="dss-qform" id="dssQForm">' +
        Q.map(chipGroup).join('') +
        '<div class="dss-qgroup"><div class="dss-qlabel">Your biggest frustration with your current products or treatments</div>' +
        '<textarea class="dss-qtext" id="dssComplaint" rows="2" maxlength="500" placeholder="e.g. nothing has faded my dark spots, or my skin feels tight after cleansing"></textarea></div>' +
        (opts.lastShot ? (
          '<label class="dss-collect" id="dssPhotoConsent"><input type="checkbox" id="dssUsePhoto" checked> Include my scan photo for a more accurate read. It is sent securely for this analysis only and is never stored.</label>'
        ) : '') +
      '</div>' +
      '<div class="dss-cta-row dss-qcta"><button class="dss-btn" id="dssAnalyze">Get my deep analysis</button>' +
      '<button class="dss-btn ghost" id="dssQBack">Back</button></div>' +
      '<p class="dss-disc">Cosmetic guidance only, not a medical diagnosis. Individual results vary.</p>';

    // Chip selection (single = radio-like, multi = toggle).
    stage.querySelectorAll('.dss-qgroup[data-q]').forEach(function (grp) {
      var q = Q.filter(function (x) { return x.k === grp.getAttribute('data-q'); })[0];
      grp.querySelectorAll('.dss-qchip').forEach(function (btn) {
        btn.onclick = function () {
          var v = btn.getAttribute('data-v');
          if (q.type === 'single') {
            grp.querySelectorAll('.dss-qchip').forEach(function (b) { b.classList.remove('on'); });
            btn.classList.add('on'); state[q.k] = v;
          } else {
            btn.classList.toggle('on');
            var arr = state[q.k];
            if (btn.classList.contains('on')) { if (arr.indexOf(v) < 0) arr.push(v); }
            else { state[q.k] = arr.filter(function (x) { return x !== v; }); }
          }
        };
      });
    });

    stage.querySelector('#dssQBack').onclick = function () { if (opts.onBack) opts.onBack(); };
    stage.querySelector('#dssAnalyze').onclick = function () {
      complaint = (stage.querySelector('#dssComplaint') || {}).value || '';
      var usePhoto = stage.querySelector('#dssUsePhoto');
      submit(usePhoto && usePhoto.checked);
    };

    function buildAnswers() {
      var a = {};
      Q.forEach(function (q) {
        var v = state[q.k];
        if (q.type === 'multi') { if (v.length) a[q.label] = v.join(', '); }
        else if (v && v !== 'Prefer not to say') a[q.label] = v;
      });
      if (complaint.trim()) a['Biggest frustration'] = complaint.trim();
      return a;
    }

    function submit(usePhoto) {
      var ep = window.DASOM_AI_ENDPOINT || '';
      var answers = buildAnswers();
      stage.innerHTML =
        '<p class="dss-eyebrow">Deep analysis</p><h3 class="dss-h">Reading your skin profile…</h3>' +
        (opts.lastShot && usePhoto ? '<div class="dss-view"><img src="' + opts.lastShot + '" alt="your scan"><div class="dss-line"></div></div>' : '') +
        '<p class="dss-priv">Building your personalised analysis. This takes a few seconds.</p>';

      if (!ep) { return renderError('Deep analysis is not available right now. Your scan results and routine still apply.'); }

      var body = {
        mode: 'skin', deep: true, answers: answers,
        scan: opts.scan && opts.scan.metrics ? { metrics: opts.scan.metrics, zones: opts.scan.zones } : undefined
      };
      if (opts.lastShot && usePhoto) body.imageBase64 = opts.lastShot;

      fetch(ep, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json(); })
        .then(function (d) { renderResult(d || {}); })
        .catch(function () { renderError('We could not complete the deep analysis right now. Your scan results and routine still apply.'); });
    }

    function productCard(p) {
      var buy = opts.cartOk
        ? '<button class="dss-add" data-h="' + esc(p.handle) + '">Add to cart</button>'
        : '<a class="dss-add" href="' + esc(opts.link(p.handle)) + '" target="_blank" rel="noopener">Add to cart</a>';
      return '<div class="dss-item"><div class="dss-itxt"><span class="dss-n">' + esc(p.name) + '</span>' +
        (p.reason ? '<span class="dss-pp">' + esc(p.reason) + '</span>' : '') +
        '</div>' + buy + '</div>';
    }

    function renderResult(d) {
      var reply = (d.reply || '').trim();
      var recs = d.recommend || [];
      var bundle = d.bundle || null;
      var treat = d.treatment || '';
      var prose = reply ? reply.split(/\n+/).map(function (l) { return '<p>' + esc(l) + '</p>'; }).join('') : '';

      stage.innerHTML =
        '<p class="dss-eyebrow">Your deep analysis</p><h3 class="dss-h">Your personalised read</h3>' +
        (prose ? '<div class="dss-deep">' + prose + '</div>' : '') +
        (recs.length ? '<div class="dss-rec-h">Recommended for you</div><div class="dss-rec" id="dssDeepRec">' + recs.map(productCard).join('') + '</div>' : '') +
        '<div id="dssCartMsg" class="dss-cartmsg" hidden></div>' +
        (bundle ? '<div class="dss-bundlecard"><div class="dss-itxt"><span class="dss-n">' + esc(bundle.name) + ' · ' + (function (p) {
          var n = parseFloat(p); if (isNaN(n)) return '$' + esc(p);
          var rate = parseFloat(window.DASOM_USD_RATE) || 0.73;
          return 'CA$' + n.toLocaleString('en-CA') + ' <span class="dz-usd">/ US$' + Math.round(n * rate).toLocaleString('en-US') + '</span>';
        })(bundle.price) + '</span>' +
          (bundle.reason ? '<span class="dss-pp">' + esc(bundle.reason) + '</span>' : '') + '</div>' +
          '<a class="dss-add" href="' + esc(opts.link(bundle.handle)) + '" target="_blank" rel="noopener">Shop the set</a></div>' : '') +
        (treat ? '<div class="dss-treat"><b>In-clinic option:</b> ' + esc(treat) + ' <span class="dss-treat-src">at Fresh Touch Med Spa, Ajax</span></div>' : '') +
        '<div class="dss-cta-row"><button class="dss-btn ghost" id="dssQBack2">Back to results</button></div>' +
        '<p class="dss-disc">Cosmetic guidance only, not a medical diagnosis. Individual results vary. Your photo and answers were used only for this analysis and were not stored.</p>';

      var msg = stage.querySelector('#dssCartMsg');
      function showMsg(html) { if (msg) { msg.hidden = false; msg.innerHTML = html; } }
      stage.querySelectorAll('.dss-add').forEach(function (btn) {
        if (btn.tagName !== 'BUTTON') return;
        btn.onclick = function () {
          var h = btn.getAttribute('data-h'), old = btn.textContent;
          btn.textContent = 'Adding…'; btn.disabled = true;
          opts.addToCart(h).then(function () {
            btn.textContent = 'Added ✓';
            showMsg('Added to cart. <a href="' + esc(opts.cartHref) + '" target="_blank" rel="noopener">View cart &rarr;</a>');
            setTimeout(function () { btn.textContent = old; btn.disabled = false; }, 2500);
          }).catch(function () { btn.textContent = old; btn.disabled = false; showMsg('Could not add. <a href="' + esc(opts.link(h)) + '" target="_blank" rel="noopener">Open the product page &rarr;</a>'); });
        };
      });
      var back = stage.querySelector('#dssQBack2'); if (back) back.onclick = function () { if (opts.onBack) opts.onBack(); };
    }

    function renderError(text) {
      stage.innerHTML =
        '<p class="dss-eyebrow">Deep analysis</p><h3 class="dss-h">Almost there</h3>' +
        '<p class="dss-sub">' + esc(text) + '</p>' +
        '<div class="dss-cta-row"><button class="dss-btn ghost" id="dssQBack3">Back to results</button></div>';
      var back = stage.querySelector('#dssQBack3'); if (back) back.onclick = function () { if (opts.onBack) opts.onBack(); };
    }
  }

  return { open: open };
})();
